import React, { useEffect, } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";
import { Fetch } from "../../shared/Fetch";

export interface IForm {
    open: boolean;
    singleData: any;
    reload: boolean;
    setReload: React.Dispatch<React.SetStateAction<boolean>>;
    hideDialog: () => void;
    toast: any;
}

export const Form = ({
    open,
    singleData,
    reload,
    setReload,
    hideDialog,
    toast
}: IForm) => {

    const dateFormatOptions = [
        { label: "DD/MM/YYYY (15/04/2026)", value: "DD/MM/YYYY" },
        { label: "MM/DD/YYYY (04/15/2026)", value: "MM/DD/YYYY" },

        { label: "DD-MM-YYYY (15-04-2026)", value: "DD-MM-YYYY" },
        { label: "MM-DD-YYYY (04-15-2026)", value: "MM-DD-YYYY" },

        { label: "YYYY-MM-DD (2026-04-15)", value: "YYYY-MM-DD" },
        { label: "YYYY/MM/DD (2026/04/15)", value: "YYYY/MM/DD" },

        { label: "DD MMM YYYY (15 Apr 2026)", value: "DD MMM YYYY" },
        { label: "MMM DD, YYYY (Apr 15, 2026)", value: "MMM DD, YYYY" },

        { label: "DD MMMM YYYY (15 April 2026)", value: "DD MMMM YYYY" },
        { label: "MMMM DD, YYYY (April 15, 2026)", value: "MMMM DD, YYYY" }
    ];

    const allowedFormats = dateFormatOptions.map(o => o.value);
    const schema = yup.object({
        dateFormat: yup
            .string()
            .required("Date Format is required")
            .oneOf(allowedFormats, "Invalid date format")
    });


    const { control, handleSubmit, reset, } = useForm({
        resolver: yupResolver(schema),
        defaultValues: singleData || ""
    });

    useEffect(() => {
        if (singleData?.dateFormat) {
            reset({ dateFormat: singleData.dateFormat });
        } else {
            reset({ dateFormat: "" });
        }
    }, [singleData, reset]);

    const onSubmit = async (data: any) => {
        const isEdit = !!singleData?.id;
        const method = isEdit ? "PUT" : "POST";
        const url = isEdit ? "updateDateSetting" : "saveDateSetting";
        const message = isEdit ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch(`Website_Settings/${url}`, method, data, null, toast);

        if (response) {
            toast.current?.show({ severity: "success", summary: "Success", detail: message, life: 3000 });
            setReload(prev => !prev);
            hideDialog();
        }
    };

    return (
        <Dialog visible={open} onHide={hideDialog} header="Add / Edit Date Setting" modal style={{ width: "40vw" }} className="p-fluid" >
            <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
                <div className="col-6">
                    <label className="font-medium mb=2">
                        Date Format <span className="text-red-500">*</span>
                    </label>
                    <Controller name="dateFormat" control={control} render={({ field, fieldState }) => (
                        <>
                            <Dropdown {...field} options={dateFormatOptions} placeholder="Select Date Format" className={`w-full ${fieldState.error ? "p-invalid" : ""}`} />
                            {fieldState.error && (
                                <small className="p-error">{fieldState.error.message}</small>
                            )}
                        </>
                    )}
                    />
                </div>
                <div className="col-12 flex justify-content-end gap-3 mt-4">
                    <Button label="SAVE" type="submit" />
                    <Button label="CLOSE" type="button" className="p-button-outlined" onClick={hideDialog} />
                </div>
            </form>
        </Dialog>
    );
};



